import {
  FilterOutlined,
  LinkOutlined,
  MoonOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  SunOutlined,
} from '@ant-design/icons'
import { GraviButton, Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Flex, Radio, Tooltip } from 'antd'
import { Input, Select } from 'antd'
import { memo } from 'react'
import { useSchedulePageFilters } from '../../Context/Filters/SchedulePageFilterContext'
import { AddCarrierDrivers } from './AddCarrierDrivers'

type ScheduleHeaderProps = {
  title: string
}
const sortItems = [
  { value: 'name' as const, label: 'Name' },
  { value: 'depot' as const, label: 'Depot' },
  { value: 'shiftStart' as const, label: 'Shift Start' },
]
// const groupByItems = [
//   { value: 'depot', label: 'By Depot' },
//   { value: 'shift', label: 'By Shift' },
// ]
const errorFilters = [
  {
    key: 'oos' as const,
    label: 'OOS/Inactive Tractor',
    icon: <MaterialIcon icon='warning' />,
  },
  {
    key: 'conflict' as const,
    label: 'Scheduling Conflict',
    icon: <MaterialIcon icon='event_busy' />,
  },
  {
    key: 'missing' as const,
    label: 'Missing Equipment',
    icon: <LinkOutlined />,
  },
]
function _LeftHeader({ title }: ScheduleHeaderProps) {
  const { setFilters, sortType, sortDirection, nameFilter, shiftFilter, viewMode, errorFilter } =
    useSchedulePageFilters()

  return (
    <Vertical key={viewMode} className='px-3' verticalCenter border='right' flex={1} gap={8}>
      <Horizontal verticalCenter justifyContent='space-between' width='100%'>
        <Texto category='h5' style={{ flex: 1, whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {title}
        </Texto>
        {viewMode === 'driver' && (
          <Radio.Group
            value={shiftFilter}
            size='small'
            onChange={(v) => setFilters((f) => ({ ...f, shiftFilter: v.target.value }))}
          >
            <Radio.Button>All</Radio.Button>
            <Radio.Button value='am'>
              <SunOutlined />
            </Radio.Button>
            <Radio.Button value='pm'>
              <MoonOutlined />
            </Radio.Button>
          </Radio.Group>
        )}
      </Horizontal>

      <Input
        style={{ width: '100%' }}
        prefix={<MaterialIcon icon='search' style={{ color: 'var(--gray-400)' }} />}
        allowClear
        value={nameFilter}
        placeholder={`Search ${viewMode}`}
        onChange={(v) => setFilters((filters) => ({ ...filters, nameFilter: v.target.value }))}
      />

      <Horizontal gap={8} style={{ width: '100%', flexWrap: 'wrap' }}>
        {viewMode === 'driver' && <AddCarrierDrivers />}
        <Tooltip title='Change sort direction'>
          <GraviButton
            type='default'
            size='small'
            onClick={() =>
              setFilters((filters) => ({ ...filters, sortDirection: filters.sortDirection === 'asc' ? 'desc' : 'asc' }))
            }
            icon={sortDirection === 'asc' ? <SortAscendingOutlined /> : <SortDescendingOutlined />}
          />
        </Tooltip>
        <div style={{ flex: 1 }}>
          <Tooltip title='Sort by'>
            <Select
              style={{ width: '100%' }}
              size='small'
              options={viewMode === 'driver' ? sortItems : sortItems.filter((x) => x.value !== 'shiftStart')}
              value={sortType}
              onChange={(v) => setFilters((filters) => ({ ...filters, sortType: v }))}
            />
          </Tooltip>
        </div>
        {/* we'll add grouping back in another day */}
        {/* <div style={{ flex: 1 }}>
          <Select
            style={{ width: '100%' }}
            prefix={<UnorderedListOutlined />}
            size='small'
            placeholder='No Grouping'
            allowClear
            options={groupByItems}
            value={grouping}
            onChange={(v) => setFilters((filters) => ({ ...filters, grouping: v }))}
          />
        </div> */}
      </Horizontal>
      <Select
        mode='multiple'
        allowClear
        prefix={<FilterOutlined />}
        placeholder='Error Filters'
        value={errorFilter ?? []}
        onChange={(v) => setFilters((filters) => ({ ...filters, errorFilter: v }))}
        options={errorFilters.map((x) => ({
          value: x.key,
          label: x.icon,
          desc: x.label,
        }))}
        optionRender={({ data }) => (
          <Flex align='center' gap={2}>
            {data.label}
            <Texto>{data.desc}</Texto>
          </Flex>
        )}
      />
    </Vertical>
  )
}

export const LeftHeader = memo(_LeftHeader)
